import { render } from "./Calendar.vue?vue&type=template&id=a6f8924a"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__